export const defaultSiteConfig = {
  agencyId: 0,
  name: "",
  shortName: "必过网",
  title: "必过学习平台",
  logo: "/img/logo.png",
  logoFB: "/img/logo.png",
  logoLink: "/",
  titleIcon: "",
  companyName: "",
  domain: process.env.VUE_APP_WEB_DOMAIN,
  mDomain: "m.beegoedu.com",
  theme: "overall",
  footerAdr: "广州市黄埔区科学大道99号科汇金谷四街11号9楼",
  footerTel: "400-001-5920",
  footerQQ: "2096691720",
  icpNumber: "粤ICP备13083939号",
  networkRecord: "粤44011202000208",
  certificate: "",
  sidebarQQType: 1,
  sidebarQQ: "2096691720",
  sidebarQRCode: "/img/wx-qrcode.jpg",
  sidebarTel: "400-001-5920",
  isShowAppQrcode: true,
  isQa: 1,
  isAllowRegister: false,
  status: 1,
  isShowProductValid: 1, //是否显商品有效期
  waterMark: "/Upload/unconfig/watermark.png",
  waterMarkPosition: 4,
  rateViewPpt: 80,
  isAllowTrail: true,
  isShowBar: 1, //是否显示客服侧边栏
  tryAndSee: 1,
};
